import { render } from "./TwoFactorStart.vue?vue&type=template&id=18b3b8b4&scoped=true"
import script from "./TwoFactorStart.vue?vue&type=script&lang=ts"
export * from "./TwoFactorStart.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-18b3b8b4"

export default script